<template>
  <div>
   <b-overlay
      :show="loading"
      rounded="sm"
    >
    
    <b-row>
      <b-col cols="3">
      <b-card>
        <!-- <b-form-group
          label="Status"
          label-for="Status"
        >
        <v-select
         v-model="selected_status"
         :reduce="status => status.value"
        :options="statusOptions"
        :clearable="false"
        :filterable="false" />
      
    </b-form-group> -->
    <!-- <b-form-group
          label="Target Type"
          label-for="Target Type"
        >
        <v-select
         v-model="target_type"
         :reduce="status => status.value"
        :options="targetOptions"
        :clearable="false"
        :filterable="false" />
      
    </b-form-group> -->
    <b-form-group
          label="Date"
          label-for="Date"
        >
      <flat-pickr
          v-model="rangeDate"
          class="form-control mb-1 mr-1"
          :config="{ mode: 'range'}"
        />
        </b-form-group>
        <!-- <b-form-group
          label="From "
          label-for="Start "
        >
        <b-form-input
                 id="from"
                  v-mask="'##:##'"
                 v-model="time.from"
                 trim
               />
      </b-form-group>
      <b-form-group
          label="To "
          label-for="To"
        >
        <b-form-input
                 id="to"
                  v-mask="'##:##'"
                 v-model="time.to"
                 trim
               />
      </b-form-group> -->
      <b-button
            variant="primary"
            class="my-2"
            @click="get_data()"
            block
          >
            <span class="text-nowrap">Submit</span>
          </b-button>
        <hr class="my-2"/>
          <b-button
            variant="outline-primary"
            class="mb-1"
            block
            @click="exportToExcel()"
          >
            <span class="text-nowrap">Export</span>
          </b-button>
      </b-card>
      </b-col>
      <b-col cols="9">
   
    <!-- table -->
        <b-card>
    <b-table
      ref="selectableTable"
      selectable
      :select-mode="selectMode"
      :items="items"
      @row-selected="stranger_image"
      :fields="fields"
      responsive
      striped
      class="mb-0"
    >
      <template #cell(actions)="data">
        <b-dropdown
          variant="link"
          no-caret
          :right="$store.state.appConfig.isRTL"
        >

          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>
          <b-dropdown-item :to="{ name: 'apps-Member-view', params: { id: data.item.id } }">
            <feather-icon icon="FileTextIcon" />
            <span class="align-middle ml-50">Details</span>
          </b-dropdown-item>

          <b-dropdown-item :to="{ name: 'apps-Member-edit', params: { id: data.item.id } }">
            <feather-icon icon="EditIcon" />
            <span class="align-middle ml-50">Edit</span>
          </b-dropdown-item>

          <b-dropdown-item>
            <feather-icon icon="TrashIcon" />
            <span class="align-middle ml-50">Delete</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
      <template #cell(target_name)="data">
         <b-link v-if="data.item.target_type == 'MEMBER'" :to="'/apps/member/edit/'+data.item.taget_token+'/'"><b>{{data.item.target_name}}</b></b-link>
         <b-link v-if="data.item.target_type == 'STAFF'" :to="'/apps/staff/edit/'+data.item.taget_token+'/'"><b>{{data.item.target_name}}</b></b-link>
         <span v-if="data.item.tags !== null">
         <b-badge v-for="tag in data.item.tags" :key="index" class='ml-1' :variant="'warning'">
          {{tag}}
        </b-badge>
        </span>
        </template>
      <template #cell(status_number)="data">
        <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge>
      </template>
    </b-table>

    <b-row>
      <b-col class="mt-1">
        Total Rows : {{ totalRows }}
      </b-col>
      <b-col>

      </b-col>
    </b-row>
  </b-card>
    </b-col>
    </b-row>
    </b-overlay>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'
import {
  BMedia,
  BMediaAside,
  BCardHeader,BOverlay,
  BCardTitle,
  BMediaBody,BCard, BImg , BTable,BTime, BAvatar, BCardBody, BLink,BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BInputGroupPrepend,BModal, VBModal} from 'bootstrap-vue'
export default {
  components: {
    moment,
    BImg,
    BCard,
    BCardHeader,
    BCardTitle,
    flatPickr,
    BOverlay,
    BTable,
    BModal, VBModal,
    BAvatar,
    BLink,
    BBadge,
    BRow,
    BCol,
    ToastificationContent,
    BMedia,
  BMediaAside,
  BMediaBody,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BButton,
    BPagination,
    BCardCode,
    BTable,
    BButton,
    BTime,
    BFormGroup,
    BAvatar,
    BCardBody,
    BBadge,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      selected_status : 'ALL',
      rangeDate: null,
      test_string : null,
      user_id : 'all',
      stat : {
        records : 0,
        members : 0
      },
      loading:false,
      staffOptions : [],
      target_type:'ALL',
      headerTitle: [],
      headerVal: [],
      genderOptions: [
        { label: 'Male', value: 'M' },
        { label: 'Female', value: 'F' },
      ],
      planOptions: [
        { label: 'Basic', value: 'basic' },
        { label: 'Company', value: 'company' },
        { label: 'Enterprise', value: 'enterprise' },
        { label: 'Team', value: 'team' },
      ],
      targetOptions: [
        { label: 'ALL', value: 'ALL' },
        { label: 'STAFF', value: 'STAFF' },
        { label: 'MEMBER', value: 'MEMBER' }
      ],
      statusOptions: [
        { label: 'GRANT', value: 'GRANT' },
        { label: 'DENY', value: 'DENY' },
        { label: 'WARNING', value: 'WARNING' },
      ],
      centerOptions: [],
      salary: 0,
      isAddNewMemberSidebarActive: false,
      stranger : {
        in_time : null
      },
      searchString: null,
      time:{
        from:'00:00',
        to:'23:59'
      },
      stranger_image_src: null,
      perPage: 10,
      startRow: 1,
      endRow: 10,
      pageOptions: [10, 15, 20],
      totalRows: 1,
      currentPage: 1,
      fields: [],
      /* eslint-disable global-require */
      items: [],
      /* eslint-disable global-require */
      status: [{
        1: 'Grant', 2: 'Deny',3:'Warning'
      },
      {
        1: 'light-success', 2: 'light-danger',3: 'light-warning'
      }],
      selectMode: 'single',
      selected: [],
    }
  },
  watch: {
    user_id : {
      handler(newValue, oldValue) {
        this.get_data()
      },
    },
    rangeDate : {
      handler(newValue, oldValue) {
        this.get_data()
      },
    },
    selected_status : {
      handler(newValue, oldValue) {
        this.get_data()
      },
    },
    currentPage: {
      handler(newValue, oldValue) {
        this.get_data()
      },
    },
    searchString: {
      handler(newValue, oldValue) {
        // console.log("search")
        this.searchString = newValue.toUpperCase()
        this.handleSearch()
      },
    },
    perPage: {
      handler(newValue, oldValue) {
        if (newValue < 9) {
          this.perPage = 10
        }
        // console.log("search")
        this.handleSearch()
      },
    },
  },
  created() {
    this.get_data()
  },
  methods: {
    exportToExcel() {
         import('@/@core/Export2Excel').then(excel => {
           const list = this.items
   
           const data = this.formatJson(this.headerVal, list)
           excel.export_json_to_excel({
             header: this.headerTitle,
             data,
             filename: 'monthly-schedule',
             autoWidth: true,
             bookType: 'xlsx'
           })
           //this.clearFields()
         })
       },
formatJson(filterVal, jsonData) {
  return jsonData.map(row =>
    filterVal.map(key => {
      const value = row[key]
      const type = this.fieldTypes[key]

      if (value === null || value === '') return ''

      switch (type) {
        case 'int':
          return parseInt(value)
        case 'float':
          return parseFloat(value)
        case 'boolean':
          return value ? 'Yes' : 'No'
        case 'date':
          return moment(value).format('YYYY-MM-DD')
        case 'datetime':
          return moment(value).format('YYYY-MM-DD HH:mm')
        default:
          return value
      }
    })
  )
},

 get_data() {
    this.loading = true
var splitted = []
          if (this.rangeDate === null) {
            splitted[0] = moment().subtract(30, 'days').format('YYYY-MM-DD')
            splitted[1] = moment().format("YYYY-MM-DD")
            this.rangeDate = moment().subtract(30, 'days').format('YYYY-MM-DD') + " to " + moment().format("YYYY-MM-DD")
          } else {
            splitted = this.rangeDate.split(" to ");
          }
    const token = JSON.parse(localStorage.getItem('userData')).token
    const centerId = this.$store.getters['center/currentCenterId']
    const userId = this.selected_user_id ?? 'all'
    const selectedRoom = this.selected_rooms ?? 'all'
  this.$http.get(process.env.VUE_APP_API_BASE + '/report/pt-session/'+centerId+`/?from=`+splitted[0]+`&to=`+splitted[1])
    .then(res => {
            this.loading = false

        if (res.data.result === false) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
            return
        }
      this.fields = res.data.fields
      this.items = res.data.records
      this.headerTitle = res.data.excel_fields.map(f => f.label)
      this.headerVal = res.data.excel_fields.map(f => f.key)
      this.fieldTypes = res.data.excel_fields.reduce((map, f) => {
        map[f.key] = f.type
        return map
      }, {})
    })
},
    stranger_image(image) {
      this.stranger = image[0]
      console.log(this.stranger)
      if (image[0].target_type != 'STRANGER') { return }
      this.stranger.image = 'data:image/jpg;base64,'+image[0].image

      this.$refs['modal-stranger'].show()
    },
    get_center_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/centers/')
        .then(res => {
          this.centerOptions = res.data.centers
        })
    },
    handleChangePage() {

    //  this.get_data()
    },
    onRowSelected(items) {
      this.selected = items[0]
      console.log(items)
      if (items[0].is_pdf == 'Y') {
        //this.iframe_src = '//www.cloudfit.pro/pdf/INVOICE_'+items[0].code+'.pdf'
        //console.log(this.iframe_src)

      } else {
      //this.iframe_src = process.env.VUE_APP_API_BASE+'/invoice.php?print=n&code='+items[0].id
      }
      //this.transaction_id = items[0].transaction_id
    //  this.$refs['my-modal'].show()
    },

    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    selectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.selectRow(2)
    },
    unselectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.unselectRow(2)
    },

    handleSearch() {
      // let _print = `The user searched for: ${searching}\n`
      // this.$refs.pre.appendChild(document.createTextNode(_print))
    // this.searchString = searching
    // this.currentx = 1
    // this.get_data()
      this.searchTimeOut()
    },
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        // your code
        this.currentPage = 1
        this.get_data()
      }, 500)
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style lang="scss">
.b-table-selectable{
  .feather{
    font-size: 1.3rem;
  }
}

</style>
